/**
 * Typ eines Termins – zentrale Stelle (Ralph 01.11.2026: Typ ist eine Liste, die er selbst pflegt).
 * Liste: Textvorlagen doc_type "termin_typ" (AuswahlFeld). Gespeichert wird die Bezeichnung;
 * alte Termine tragen noch den Schlüssel (z. B. "ausfuehrung") und werden hier übersetzt.
 * Gegenstück im Backend: backend/utils/termin_typ.py.
 */
export const TYP_ALT = {
  besichtigung: "Besichtigung",
  ausfuehrung: "Ausführung",
  abnahme: "Abnahme",
  intern: "Intern",
  sonstiges: "Sonstiges",
};
export const TYP_GRUNDBESTAND = Object.values(TYP_ALT);
export const TYP_STANDARD = "Ausführung";

/** Alter Schlüssel -> Bezeichnung; eine Bezeichnung bleibt, wie sie ist. */
export const typBezeichnung = (wert) => {
  const w = typeof wert === "string" ? wert.trim() : "";
  return TYP_ALT[w.toLowerCase()] || w;
};

/** Ist der gespeicherte Wert (Schlüssel ODER Bezeichnung) der Typ `schluessel`? */
export const istTyp = (wert, schluessel) =>
  typeof wert === "string" && [schluessel, TYP_ALT[schluessel]].some((x) => x && x.toLowerCase() === wert.trim().toLowerCase());
